<template>
  <v-app id="inspire">
    <my-side-bar :drawer="drawer"></my-side-bar>
    <my-header @changeDrawer="updateDrawer" :drawer="drawer" ></my-header>
    
    <v-main>
      <v-container class="" fluid>
        <v-row class="px-3">
          <v-card>
            <v-card-title cols="12" >
              Gestione Ruolo
              <v-spacer></v-spacer>
            </v-card-title>
           <div>
             <div class="text-center" v-if="isLoading">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
            <v-form ref="form">
              <v-container>
                <v-row cols="12">
                  <v-col cols="12" sm="6" md="3" >
                    <v-text-field label="Role" v-model="role.role_name" :readonly="role_readonly"></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="userLoggedPermissions.manage_user_role_permissions">
                  <label>Permessi</label>
                  <v-col cols="12" sm="12" md="12" >
                    <ul>
                      <li v-for="p in objPermissions" :key="p.id">
                        <v-row>
                          <v-col cols="12" sm="12" md="3">
                            <v-checkbox
                              :label="p.name"
                              color="primary"
                              :value="p.active"
                              hide-details
                              v-model="p.active"
                            ></v-checkbox>
                          </v-col>
                          <v-col cols="12" sm="12" md="3">
                            <v-checkbox
                              label="Write"
                              color="primary"
                              :value="p.write"
                              hide-details
                              v-model="p.write"
                            ></v-checkbox>
                          </v-col>
                          <v-col cols="12" sm="12" md="3">
                            <v-checkbox
                              label="Delete"
                              color="primary"
                              :value="p.delete"
                              hide-details
                              v-model="p.delete"
                            ></v-checkbox>
                          </v-col>
                        </v-row>
                      </li>
                    </ul>
                  </v-col>
                </v-row>
                <!--<v-row>
                  <v-btn color="success" class="mr-4" @click="saveRolePermission">
                    Salva
                  </v-btn>
                </v-row>-->
              </v-container>
            </v-form>
          </div>
          </v-card>
        </v-row>
      </v-container>
      <v-speed-dial
            v-model=fab
            :top=top
            :bottom=bottom
            :right=right
            :left=left
            :direction=direction
            :open-on-hover=hover
            :transition=transition
          >
            <template v-slot:activator>
              <v-btn v-model="fab" color="blue darken-2" dark fab>
                <v-icon v-if="fab">
                  mdi-close
                </v-icon>
                <v-icon v-else>
                  mdi-account-check
                </v-icon>
              </v-btn>
            </template>
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn fab dark small v-bind="attrs" v-on="on" color="green" @click="saveRolePermission">
                  <v-icon>mdi-content-save-edit-outline</v-icon>
                </v-btn>
              </template>
              <span>Salva Ruolo</span>
            </v-tooltip>
            <v-tooltip left v-if="http_verb==='put'">
              <template v-slot:activator="{ on, attrs }">
                <v-btn fab dark small v-bind="attrs" v-on="on" color="red" @click="deleteRole">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Cancella Ruolo</span>
            </v-tooltip>
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn fab dark small v-bind="attrs" v-on="on" color="indigo" @click="backToRoles" >
                  <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
              </template>
              <span>Vai alla lista</span>
            </v-tooltip>
          </v-speed-dial>
    </v-main>
  </v-app>
</template>

<script>
  import SideBar from '../components/SideBar.vue';
  import Header from '../components/Header.vue';
  
  //import { VueGoodTable } from 'vue-good-table';
  // import the styles
  //import 'vue-good-table/dist/vue-good-table.css'
  import {permissionsUrl, getHeader } from '../config.js';

  import router from '../router';
  import { store } from '../store';

  const axios = require('axios');

  export default {
    props: {
      source: String,
    },
    components:{
      'my-side-bar':SideBar,
      'my-header':Header
    },
    data: () => ({
      //start fab conf
      direction: 'top',
      fab: false,
      fling: true,
      hover: false,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: 'slide-y-reverse-transition',
      //end fab conf
      dialog: false,
      drawer: true,
      isLoading: true,
      roleId: null,
      role: {},
      objPermissions: {},
      role_readonly: true,
      http_verb: '',
      userLogged: {},
      userLoggedPermissions: {} 
    }),
    watch: {
    },
    async mounted () {

      this.userLogged = store.state.user;
      this.userLoggedPermissions = store.state.permissions;

      if(this.userLoggedPermissions.manage_user_roles === undefined){
        this.$fire({
          title: "Accesso Negato",
          text: "Non si hanno i privilegi per accedere a questa pagina",
          type: "error",
          timer: 5000
        }).then(r => {
          console.log(r.value);
        });

        router.push({name:'Home'});

      }

      console.log('roleId', this.$route.params.roleId);
      this.roleId = this.$route.params.roleId;

      if(this.userLoggedPermissions.manage_user_role_permissions){
        await this.getPermissions();
      }

      if(this.roleId){
        this.getFromServer();
        this.http_verb = 'put';
      }else{
        this.role = {role_name : ''}
        this.role_readonly = false;
        this.http_verb = 'post';
        this.isLoading = false;
      }
      
    },
    methods: {
      updateDrawer(value){
        this.drawer = value;
      },
      getFromServer(){

        var header = getHeader();

        axios.get(permissionsUrl + '/' + this.roleId, {
              headers: {
                'Accept' : header.Accept,
                'Authorization' : header.Authorization
              }
            })
            .then((response) => {
                // handle success
                console.log(response.data);

                if(response.data && response.data.permissions){

                  this.role = response.data.role;
                  console.log('new permission', response.data.permissions);
                  this.showPermission(response.data.permissions);

                  this.isLoading = false;

                }

            })
            .catch(function (error) {
                // handle error
                alert(error)
            });

      },
      saveRolePermission(){

        this.isLoading = true;

        if(this.role.role_name){

          console.log(this.objPermissions);

          var header = getHeader();

          var objToSave = {
            role : this.role,
            permission : this.objPermissions
          };

          if (this.http_verb === 'put'){

            axios.put(permissionsUrl + '/' + this.roleId, objToSave, {
              headers: {
                'Accept' : header.Accept,
                'Authorization' : header.Authorization
              }
            })
            .then((response) => {
                console.log(response);

                if(response.data.result === "OK"){
                  
                  this.$fire({
                    title: "Dati salvati",
                    text: "Salvataggio avvenuto con successo",
                    type: "success",
                    timer: 5000
                  }).then(r => {
                    console.log(r.value);
                  });

                }else{

                  var text = response.data.msg != '' ? response.data.msg : "Dati inseriti non validi, si prega di verificare.";
                  this.$fire({
                    title: "Errore nei dati!",
                    text: text,
                    type: "error",
                    timer: 5000
                  }).then(r => {
                    console.log(r.value);
                  });

                }

                this.isLoading = false;
                
            })
            .catch(function (error) {
                // handle error
                alert(error);
                this.isLoading = false;
            });

          }else{
            
            axios.post(permissionsUrl, objToSave, {
              headers: {
                'Accept' : header.Accept,
                'Authorization' : header.Authorization
              }
            })
            .then((response) => {
                console.log(response);

                if(response.data.result === "OK"){
                  
                  this.$fire({
                    title: "Dati salvati",
                    text: "Salvataggio avvenuto con successo",
                    type: "success",
                    timer: 5000
                  }).then(r => {
                    console.log(r.value);
                  });

                  this.backToRoles();

                }else{

                  var text = response.data.msg != '' ? response.data.msg : "Dati inseriti non validi, si prega di verificare.";
                  this.$fire({
                    title: "Errore nei dati!",
                    text: text,
                    type: "error",
                    timer: 5000
                  }).then(r => {
                    console.log(r.value);
                  });

                }

                this.isLoading = false;
                
            })
            .catch(function (error) {
                // handle error
                alert(error);
                this.isLoading = false;
            });

          }

        }else{
          this.$fire({
            title: "Errore nei dati!",
            text: "Dati inseriti non validi, si prega di verificare.",
            type: "error",
            timer: 5000
          }).then(r => {
            console.log(r.value);
          });
        }

        this.isLoading = false;

      },
      showPermission(newPermission){

        console.log('new permission', newPermission);
        console.log('old permission', this.objPermissions);

        var objPermissions = this.objPermissions;

        for (const [key] of Object.entries(objPermissions)) {
          objPermissions[key].active = 0;
          objPermissions[key].write = 0;
          objPermissions[key].delete = 0;
        }

        console.log('reset objPermission' , objPermissions);

        if(newPermission.length > 0){
          newPermission.forEach(function(item){
            console.log('itero per', item);
            objPermissions[item.permission_name].active = 1;
            objPermissions[item.permission_name].write = item.write;
            objPermissions[item.permission_name].delete = item.delete;
          });
        }

        this.objPermissions = objPermissions;

      },
      async getPermissions(){
        var header = getHeader();

        var res = await axios.get(permissionsUrl, {
              headers: {
                'Accept' : header.Accept,
                'Authorization' : header.Authorization
              }
            })
            .then((response) => {
                // handle success
                //console.log(response.data);
                var objPermissions = {};

                if(response.data && response.data.rows){

                  response.data.rows.forEach(function(item){
                    
                      objPermissions[item.permission_name] = {
                        'id' : item.id,
                        'name' : item.permission_name,
                        'active' : 0,
                        'write' : 0,
                        'delete' : 0
                      };

                  });

                }

                this.objPermissions = objPermissions;
                console.log('objPermissions', objPermissions);

                return true;
            })
            .catch(function (error) {
                // handle error
                alert(error)
            });

          return res;
      },
      backToRoles(){
        router.push({name:'Roles'});
      },
      deleteRole(){
        
        this.$fire({
          title: 'Sei sicuro?',
          text: "L'operazione non sarà reversibile!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Si, cancella!'
        }).then(r => {
            if(r.value){
              
              this.isLoading = true;

              var header = getHeader();

              axios.delete(permissionsUrl + '/' + this.roleId, {
              headers: {
                'Accept' : header.Accept,
                'Authorization' : header.Authorization
              }
            })
            .then((response) => {
                console.log(response);

                if(response.data.affected == "1"){
                  
                  this.$fire({
                    title: "Cancellato!",
                    text: "Ruolo cancellato con successo",
                    type: "success",
                    timer: 5000
                  }).then(r => {
                    console.log(r.value);
                  });

                  this.backToRoles();

                }else{

                  var text = response.data.msg != '' ? response.data.msg : "E' avvenuto un errore, si prega di riprovare.";
                  this.$fire({
                    title: "Errore!",
                    text: text,
                    type: "error",
                    timer: 5000
                  }).then(r => {
                    console.log(r.value);
                  });

                }
                this.isLoading = false;
                
            })
            .catch(function (error) {
                // handle error
                alert(error);
                this.isLoading = false;
            });

          }
        });

      }
    },
    computed: {
      user(){
        return this.$store.state.user;
      }
    }
  }
</script>

<style scoped>
.v-card{
  width:100%;
}
   .v-speed-dial {
    position: absolute;
  }

   .v-btn--floating {
    position: relative;
  }
</style>
